const NextSpellCard = ({ dataIco, children }: { dataIco: string; children?: any }) => {
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        width: '15%',
      }}
    >
      <span
        style={{
          color: '#ffffff',
          fontSize: '1em',
          fontWeight: 'bold',
          letterSpacing: '0.2em',
          fontFamily: 'HellghostRough',
          textShadow: `0px 1px 0 #430064, 1px 0px 0 #430064, -1px 0px 0 #430064, 0px -1px 0 #430064,
        0px 2px 0 #430064, 2px 0px 0 #430064, -2px 0px 0 #430064, 0px -2px 0 #430064,
        0px 3px 0 #430064, 3px 0px 0 #430064, -3px 0px 0 #430064, 0px -3px 0 #430064,
        0px 4px 0 #430064, 4px 0px 0 #430064, -4px 0px 0 #430064, 0px -4px 0 #430064`,
        }}
      >
        next
      </span>
      <div
        style={{
          height: 50,
          width: '100%',
          // marginBottom: selected ? '0' : '-20px',
          border: '1px dashed #0000ffaa',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          position: 'relative',
          transition: 'margin 0.2s linear',
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/theme/sheet.svg')`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          filter: 'grayscale(100%)',
          paddingTop: '10px',
        }}
      >
        <div data-ico={dataIco} className="spell-card-preview">
          {children}
        </div>
        {/* <img src={`${process.env.PUBLIC_URL}/assets/images/theme/sheet.svg`} /> */}
      </div>
    </div>
  )
}

export default NextSpellCard
